import React, { useEffect, useState } from 'react';

const PlayerUiHpWidget = ({ creature, socket }) => {
    const [hpChange, setHpChange] = useState(0);
    const [tempHp, setTempHp] = useState(creature.hit_points_temp ?? 0);
    const [overrideHp, setOverrideHp] = useState(creature.hit_points_override ?? 0);
    const [armorClass, setArmorClass] = useState(creature.armor_class ?? 0);
    const [currentHp, setCurrentHp] = useState(creature.hit_points_current ?? 0);
    const [maxHp, setMaxHp] = useState(creature.hit_points ?? 0);

    useEffect(() => {
        setTempHp(creature.hit_points_temp ?? 0);
        setOverrideHp(creature.hit_points_override ?? 0);
        setArmorClass(creature.armor_class ?? 0);
        setCurrentHp(creature.hit_points_current ?? 0);
        setMaxHp(creature.hit_points ?? 0);
    }, [creature.creatureGuid, creature.hit_points_current, creature.hit_points_temp, creature.hit_points_override, creature.armor_class, creature.hit_points]);

    const handleChangeHpCreature = (type, event) => {
        event.stopPropagation();

        const parsedHpChange = Number.parseInt(hpChange, 10) || 0;
        let nextHpChange = parsedHpChange;
        let nextTempHp = tempHp;
        let nextCurrentHp = currentHp;

        if (type === 'damage') {
            if (nextTempHp > 0) {
                const tempHpRemainder = nextTempHp - parsedHpChange;
                if (tempHpRemainder <= 0) {
                    nextHpChange = Math.abs(tempHpRemainder);
                    nextTempHp = 0;
                } else {
                    nextHpChange = 0;
                    nextTempHp = tempHpRemainder;
                }
            } else {
                nextHpChange = -parsedHpChange;
            }

            nextCurrentHp = currentHp + nextHpChange;
        } else {
            nextCurrentHp = currentHp + parsedHpChange;
        }

        nextCurrentHp = Math.min(nextCurrentHp, maxHp);

        setCurrentHp(nextCurrentHp);
        setTempHp(nextTempHp);

        socket.emit('playerHpChange', {
            hit_points_current: nextCurrentHp,
            hit_points_temp: nextTempHp,
        }, creature.creatureGuid, 'player');
    };

    const handleTempHp = (event) => {
        const parsedTempHp = Number.parseInt(event.target.value, 10);
        setTempHp(Number.isNaN(parsedTempHp) ? 0 : parsedTempHp);
    };

    const submitTempHpChange = () => {
        socket.emit('playerHpChange', { hit_points_temp: tempHp }, creature.creatureGuid, 'player');
    };

    const handleOverrideHp = (event) => {
        const parsedOverride = Number.parseInt(event.target.value, 10) || 0;
        const baseMaxHp = creature.hit_points_default || creature.hit_points || 0;
        const nextMaxHp = parsedOverride === 0 ? baseMaxHp : parsedOverride;
        const currentDifference = maxHp - currentHp;
        const nextCurrentHp = Math.max(0, Math.min(nextMaxHp, nextMaxHp - currentDifference));

        setOverrideHp(parsedOverride);
        setMaxHp(nextMaxHp);
        setCurrentHp(nextCurrentHp);
    };

    const submitOverRideHpChange = () => {
        socket.emit('playerHpChange', {
            hit_points: maxHp,
            hit_points_current: currentHp,
            hit_points_override: overrideHp,
        }, creature.creatureGuid, 'player');
    };

    const handleAc = (event) => {
        const parsedAc = Number.parseInt(event.target.value, 10);
        setArmorClass(Number.isNaN(parsedAc) ? creature.armor_class ?? 0 : parsedAc);
    };

    const submitAcChange = () => {
        socket.emit('creatureArmorClassChange', armorClass, creature.creatureGuid, 'player');
    };

    const handleHighlight = (event) => {
        event.target.select();
    };

    const isDead = currentHp <= 0;
    const safeMaxHp = maxHp || 1;
    const isBloodied = currentHp / safeMaxHp < 0.55;

    let color = 'rgb(62, 172, 74)';
    if (isDead) {
        color = 'red';
    } else if (isBloodied) {
        color = 'orange';
    }

    // add max/current hp onto the widget
    // fix the other widgets spacing 
    // allow for scrolling
    // close widgets on enter
    


    return (
        <div className='hpContainerPlayerUi editHpGrowPlayerUi'>
            <div className="hpMenuPlayerUi">
                <div className='hpInputRowContainer'>
                    <div className='extraHpInputsController'>
                        <label className='widgetLabel acPlayerUi' htmlFor='ac'>Armor Class</label>
                        <input id='ac' type='number' className='editStatsInputExtraPlayerUi acPlayerUi' value={armorClass} style={{ color: tempHp === 0 ? 'grey' : '' }} onFocus={handleHighlight} onChange={handleAc} onBlur={submitAcChange} />
                    </div>
                    <hr />
                    <div className='extraHpInputsController'>
                        <label className='widgetLabel tempHpPlayerUi' style={{ color: tempHp === 0 ? 'grey' : ''}} htmlFor='temphp'>Temp.</label>
                        <input id='temphp' type='number' className='editStatsInputExtraPlayerUi tempHpPlayerUi' value={tempHp} style={{ color: tempHp === 0 ? 'grey' : '' }} onFocus={handleHighlight} onChange={handleTempHp} onBlur={submitTempHpChange} />
                    </div>
                    <div className='extraHpInputsController'>
                        <label className='widgetLabel overrideHpPlayerUi' htmlFor='override' style={{ color: overrideHp === 0 ? 'grey' : ''}}>Override</label>
                        <input id='override' type='number' className='editStatsInputExtraPlayerUi overrideHpPlayerUi' value={overrideHp} style={{ color: overrideHp === 0 ? 'grey' : '' }} onFocus={handleHighlight} onChange={handleOverrideHp} onBlur={submitOverRideHpChange} />
                    </div>
                </div>

                <div className='damageHealInputController'>
                    <button className='editHpButtonController healButtonPlayerUi' onClick={(event) => handleChangeHpCreature('heal', event)}>HEAL</button>
                    <input className='editHpInputController' type='number' value={hpChange} onFocus={handleHighlight} onChange={(event) => setHpChange(Number.parseInt(event.target.value, 10) || 0)} autoFocus />
                    <button className='editHpButtonController damageButtonPlayerUi' onClick={(event) => handleChangeHpCreature('damage', event)}>DAMAGE</button>
                </div>
            </div>
        </div>
    );
};

export default PlayerUiHpWidget;